import React from 'react';
import { createPortal } from 'react-dom';
import { elakayAutoText } from '../pageInside/dataElakay';
import { getCurrentElakayRole } from '../pageInside/Rolle';
import { getDesign, isPreviewFrame, setHeaderFooterPreview, useHeaderFooterPreview } from './headerFooterCollections';
import { designName } from './headerFooterCollectionsText';

// Reminds World Family that a design is only being previewed in this tab
// (nothing saved, visitors unaffected) and lets them leave the preview from
// any page. Rendered on <body>: the header's entrance animation would
// otherwise turn this fixed element into a header-relative one.
const HeaderFooterPreviewBanner = ({ infoSource }) => {
  const preview = useHeaderFooterPreview();
  if (!preview || isPreviewFrame() || typeof document === 'undefined') return null;
  if (getCurrentElakayRole(infoSource) !== 'Family') return null;
  return createPortal(
    <div className="hfc-preview-banner" role="status">
      <span className="hfc-preview-banner__dot" aria-hidden="true" />
      <span className="hfc-preview-banner__text">
        {elakayAutoText('h_hfc_preview_banner', 'Preview: {name} — not applied', { name: designName(getDesign(preview)) })}
      </span>
      <button type="button" className="hfc-preview-banner__stop" onClick={() => setHeaderFooterPreview(null)}>
        {elakayAutoText('h_hfc_stop_preview', 'Stop preview')}
      </button>
    </div>,
    document.body
  );
};

export default HeaderFooterPreviewBanner;
